    /* Header Menu actions */
    $('li.menu-toggle > a').on('click',function(){
        // console.log($(this).find('.badge > svg'));

        if($(this).closest('.menu-toggle').hasClass('nav-alerts')) {
            $(this).find('.badge > svg').toggleClass('fa-envelope-open fa-envelope');
        }
        var menu_link = this;
        $('li.menu-toggle > a').each(function(){
            if (this !== menu_link) {
                $(this).parent().removeClass('open');
            }
        });
        $(menu_link).parent().toggleClass('open');
        $('li.user-name.menu-toggle a').find('.fa, .svg-inline--fa').toggleClass('fa-angle-right').toggleClass('fa-angle-down');
        return false;
    });

	/* Navigation Menu actions */
	$('#sidebarCollapse').on('click', function () {
		$('#sidebar, #content').toggleClass('active');
		$('.collapse.in').toggleClass('in');
		$('a[aria-expanded=true]').attr('aria-expanded', 'false');
	});

	$(".dropdown-toggle").on('click', function() {
		$(this).parent().toggleClass('collapsed');
		$(this).parent().find('ul').toggleClass('show');
		$('a[aria-expanded=true]').attr('aria-expanded', 'false');

	});

    /* Sidebar Toggle Actions */
    $('#site-sidebar .sidebar-toggler-wrapper').on('click',function(){
        $(this).find('svg.fa-2x').toggleClass('fa-angle-double-left fa-angle-double-right');
        $('body').toggleClass('site-sidebar-closed');
        return false;
    });
    $('#page-sidebar .sidebar-toggler-wrapper').on('click',function(){
        $(this).find('svg.fa-2x').toggleClass('fa-angle-double-left fa-angle-double-right');
        $('body').toggleClass('page-sidebar-closed');
        return false;
    });

    $(document).ready(function() {
        $(document).on("click", function(e) {
            var usermenu = 'li.user-name.menu-toggle.open';
            if ($(usermenu).length) {
                if (!$(e.target).parents(usermenu).length) {
                    // dismiss user menu
                    $('li.menu-toggle > a').trigger('click');
                }
            }
        });
    });

	/* Help Toggle */
	var helpTitle = $('#page-help a').html();
	$('#page-help a').on('click',function(e){
		$('#page-help').toggleClass('help-open');
		$('#page-help-flyout').toggleClass('help-open');
		$('body').removeClass('mobile-page-sidebar-open').removeClass('mobile-site-sidebar-open');
		if ($('#page-help').hasClass('help-open')){
			$('#page-help a').html('Close ' + helpTitle);
		}
		else {
			$('#page-help a').html(helpTitle);
		}
		return false;
	});

	/* Mobile Widgets */
	$('#site-menu-widget').on('click', function(e){
		$('body').removeClass('mobile-page-sidebar-open').toggleClass('mobile-site-sidebar-open');
		$('#page-help').removeClass('help-open');
		$('#page-help-flyout').removeClass('help-open');
	});
	$('#page-menu-widget').on('click', function(e){
		$('body').removeClass('mobile-site-sidebar-open').toggleClass('mobile-page-sidebar-open');
		$('#page-help').removeClass('help-open');
		$('#page-help-flyout').removeClass('help-open');
	});

	$('#page-sidebar a').on('click', function(){
		if ($('body').hasClass('mobile-page-sidebar-open')){
			$('body').removeClass('mobile-page-sidebar-open');
		}
	});
